import { render, staticRenderFns } from "./BlockActions.vue?vue&type=template&id=0e3dd526&"
import script from "./BlockActions.vue?vue&type=script&lang=js&"
export * from "./BlockActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports